<template>
  <div class="view">

  <router-link class="btn color-primary" to="/reports/missing-payments">Manglende betaling</router-link><br>
  <router-link class="btn color-primary" to="/report-invoicability" v-if="0">Fakturérbarhed</router-link><br>
  <router-link class="btn color-primary" to="/reports/missing-input">Manglende data</router-link><br>
  <router-link class="btn color-primary" to="/report-project-earnability" v-if="0">Opgave-rentabilitet</router-link><br>
  <router-link class="btn color-primary" to="/reports/client-earning" v-if="economy_access">Kunde-indtjening</router-link><br>


  </div>
</template>

<script>
import helpers from '../helpers.js';
import mixins from '../mixins.js';
import Box from '.././components/Box'
import Btn from '.././components/Btn'
import Avatar from '.././components/Avatar'
export default {
  mixins: [ mixins.db, mixins.generic ],
  data: function () {
    return {
      
    }
  },
  computed:{

  },//computed
  methods: {

    goto(location){
      this.$router.push(location)
    },

  },//methods

  created(){
    
    if( !this.is_admin ) this.goto('/')

  },//created

  components: { Box, Btn, Avatar },
}
</script>



// WEBPACK FOOTER //
// Reports.vue?78ac92d4